<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <div class="d-block d-lg-flex justify-content-between">
            <div id="tabs">
                <tabs
                    :tabs="tabs"
                    :current-tab="currentTab"
                    :wrapper-class="'default-tabs'"
                    :tab-class="'default-tabs__item'"
                    :tab-active-class="'default-tabs__item_active'"
                    :line-class="'default-tabs__active-line'"
                    @onClick="changeTab"
                />
            </div>
            <div
                v-if="currentTabTotal !== null && currentTab !== 'concertGalleries'"
                class="pt-3 pt-lg-0 total-count"
            >
                <div v-html="totalCountText" />
            </div>
        </div>
        <div>
            <div class="content">
                <div v-if="currentTab === 'concertGalleries'">
                    <div>
                        <gallery-browser
                            :endpoint="galleryEndpoint"
                            @meta-loaded="currentTabTotal = $event.total"
                        />
                    </div>
                </div>
                <div v-else-if="currentTab === 'issuu'">
                    <publication-browser
                        :category="category"
                        :category-route="categoryRoute"
                        :locale="locale"
                        :news-endpoint="newsEndpoint"
                        @meta-loaded="currentTabTotal = $event"
                    />
                </div>
                <div v-else>
                    <BrowseByType
                        :type="currentTab"
                        :category="category"
                        :category-route="categoryRoute"
                        :locale="locale"
                        :news-endpoint="newsEndpoint"
                        @meta-loaded="currentTabTotal = $event.total"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line'
import BrowseByType from './BrowseByType'
import PublicationBrowser from '../publication-browser/PublicationBrowser.vue'

export default {
    name: 'NewsBrowser',
    components: { PublicationBrowser, BrowseByType, Tabs },
    props: {
        locale: {
            type: String,
            default: 'hu'
        },
        category: {
            type: Number,
            default: null
        },
        categoryRoute: {
            type: String,
            required: true
        },
        defaultTab: {
            type: String,
            default: 'text'
        },
        newsEndpoint: {
            type: String,
            required: true
        },
        galleryEndpoint: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            availableTabs: {
                hu: [
                    { title: 'Bejegyzések', value: 'text' },
                    { title: 'Videók', value: 'video', },
                    { title: 'Hanganyagok', value: 'sound' },
                    { title: 'Kiadványok', value: 'issuu' },
                    { title: 'Koncert galériák', value: 'concertGalleries' },
                ],
                en: [
                    { title: 'News', value: 'text' },
                    { title: 'Videos', value: 'video', },
                    { title: 'Sounds', value: 'sound' },
                    { title: 'Publications', value: 'issuu' },
                    { title: 'Concert galleries', value: 'concertGalleries' },
                ]
            },
            anchors: {
                'bejegyzesek': 'text',
                'videok': 'video',
                'hanganyagok': 'sound',
                'kiadvanyok': 'issuu',
                'koncert-galeriak': 'concertGalleries',
            },
            currentTab: null,
            currentTabTotal: null,
            tabs: [],
        }
    },
    computed: {
        totalCountText() {
            return this.locale === 'hu'
                ? 'Összesen <strong>' + this.currentTabTotal + '</strong> bejegyzés'
                : '<strong>' + this.currentTabTotal + '</strong> items total'
        },
    },

    mounted() {
        if (window.location.hash) {
            this.$nextTick(() => {
                const element = document.querySelector('#tabs')
                if (element) {
                    let currentTab = this.anchors[window.location.hash.replace('#', '')] || null

                    if (currentTab) {
                        this.currentTab = currentTab
                        const headerHeight = document.querySelector('#zen-page-header').offsetHeight || 0

                        window.scrollTo({
                            top: element.getBoundingClientRect().top + window.scrollY - headerHeight,
                            behavior: 'smooth'
                        })
                    }
                }
            })
        }
    },

    created() {
        this.tabs = this.availableTabs[this.locale]
        this.currentTab = this.defaultTab
    },

    methods: {
        changeTab(tab) {
            this.currentTab = tab
            window.location.hash = Object.keys(this.anchors).find(key => this.anchors[key] === tab)
        },
    },
}
</script>

<style lang="scss">
@import "./resources/sass/_variables.scss";

.total-count {
    color: $zh-suplementary-gray;
}

.default-tabs {
    position: relative;
    -ms-overflow-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-scroll-snap-type: x;
    scroll-snap-type: x;

    &::-webkit-scrollbar {
        display: none;
    }

    &__item {
        display: inline-block;
        padding: 0;
        margin: 0 10px;
        font-size: 14px;
        line-height: 32px;
        letter-spacing: 1.7px;
        color: $zh-blue;
        text-transform: uppercase;
        text-decoration: none;
        border: none;
        background-color: transparent;
        border-bottom: 3px solid transparent;
        cursor: pointer;
        transition: all 0.25s;
        &_active {
            font-size: 30px;
            line-height: 32px;
            border-bottom: 3px solid;
        }
        &:focus {
            outline: none;
        }
        &:first-child {
            margin-left: 0;
        }
        &:last-child {
            margin-right: 0;
        }
    }
}
.content {
    margin-top: 30px;
    font-size: 20px;
}
</style>
